export default "assets/tvs-logo.png"